import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Spin, Card } from 'antd'
import { Queries  } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import imgcontact from '../../../assets/images/contact.jpg'
import { changeFormatdate } from '../../../utils/formatdate'

const { Text, Title } = Typography

class AboutsLink extends React.Component {

    state = {
		detailAboutsLink : [],
		visibleModal: false,
	}

	fetchListDocumen = async() =>{
		const { client,location } = this.props
        const { selectMonth, selectYear } = this.state
		const { data } = await client.query({
            query: Queries.fetchListOrganizationGroup
        })
		await this.setState({
            detailAboutsLink: data.fetchListOrganizationGroup,
		})
    }
    
    async componentDidMount(){
		await this.fetchListDocumen()
	}


    render() {
        const { match,location } = this.props
        const { detailAboutsLink } = this.state
        return (
            <Container match={match} >
                <div id="page-AboutsLink-hr">
                {
                    detailAboutsLink &&
                    detailAboutsLink.map((value,keys)=>
                        <>
                            <Link to={ '/abouts/link/'+value.orgGroupId}>
                                <Row>
                                    <Col>
                                        <Card className="mb-3 card-hover-custom">
                                            <div>
                                                <Title level={4} className="mr-2 pr-1 mb-1" style={{display:"inline-block"}}>
                                                    { value.orgGroupTitle }
                                                </Title>
                                            </div>
                                        </Card>
                                    </Col>
                                </Row>
                            </Link> 
                        </>
                    )
                }
                </div>
            </Container>
        )
    }
}

AboutsLink.propTypes = {
    //
}

export default withApollo(AboutsLink)